module.exports = __webpack_public_path__ + "media/images/icon_pointer-c96dcb06.png";